import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaAngleRight, FaUser, FaKey } from "react-icons/fa6";


export default function Login() {

    useEffect(() => {
        AOS.init({ duration: 500, easing: 'ease-in-out' });
    }, []);
    //bg-gradient-to-br from-gray-800 to-blue-400




    return (
        <div className="min-h-screen flex items-center justify-center p-4" data-aos="fade-up">
            <div className=" max-w-lg w-full rounded-2xl shadow-2xl border-gray-300 border p-8 md:p-10 mt-20  ">
                <img
                    src="/images/login.jpg"
                    alt="Login"
                    className="w-48 h-48 object-cover rounded-full mx-auto mb-6 shadow-md"
                />
                <h2 className=" text-gray-800 text-5xl font-bold text-center  nunito-sans-font">Bienvenido</h2>
                <p className='text-gray-500 mt-2 text-center mb-6' >Por favor, ingrese sus credenciales</p>

                <form className="space-y-6">
                    <div className="relative w-full">
                        {/* Ícono */}
                        <div className="absolute inset-y-0 mt-2  left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                            <FaUser />
                        </div>

                        {/* Input */}
                        <input
                            type="text"
                            id="email"
                            placeholder="example@email.com"
                            className="peer w-full pl-10 border-0 border-b-2 text-lg border-gray-300 bg-transparent pt-4 pb-1 text-gray-900 placeholder-transparent focus:border-indigo-500 focus:outline-none"
                        />

                        {/* Label */}
                        <label
                            htmlFor="email"
                            className="absolute left-10 top-1 text-gray-500 transition-all 
        peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 
        peer-focus:top-0 peer-focus:text-sm peer-focus:text-indigo-500 text-lg"
                        >
                            Email
                        </label>
                    </div>


                    <div className="relative w-full">
                        {/* Ícono */}
                        <div className="absolute inset-y-0 mt-2  left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                            <FaKey />
                        </div>

                        {/* Input */}
                        <input
                            type="password"
                            id="paswword"
                            placeholder="*********"
                            className="peer w-full pl-10 border-0 border-b-2 text-lg border-gray-300 bg-transparent pt-4 pb-1 text-gray-900 placeholder-transparent focus:border-indigo-500 focus:outline-none"
                        />

                        {/* Label */}
                        <label
                            htmlFor="paswword"
                            className="absolute left-10 top-1 text-gray-500  transition-all 
        peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 
        peer-focus:top-0 peer-focus:text-sm peer-focus:text-indigo-500 text-lg"
                        >
                            Password
                        </label>
                    </div>

                    <div className="relative w-full">
                        <button
                            type="submit"
                            className="w-full mt-20 flex flex-row items-center justify-center text-xl bg-blue-600 hover:bg-blue-800 rounded-2xl text-white font-semibold py-3  transition duration-200 nunito-sans-font"
                        >
                            Ingresar
                            <FaAngleRight />
                        </button>
                    </div>
                </form>





            </div>
        </div>
    );
}
